// extracted by mini-css-extract-plugin
export default {"container":"ExpenseVehicleSection_container__8J7gd"};